module.exports = __webpack_public_path__ + "static/media/line-chart-w.dd773e4c.svg";